import VerifiedIcon from '@mui/icons-material/Verified';
import WarningIcon from '@mui/icons-material/Warning';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import SiloIdIcon from '@siloreal:assets:illustration/siloreal/product-silo-id.svg';
import SiloMetrixIcon from '@siloreal:assets:illustration/siloreal/product-silo-metrix.svg';
import SiloSatIcon from '@siloreal:assets:illustration/siloreal/product-silo-sat.svg';

const ASSETS = {
  SYSTEM: {
    ERROR: <WarningIcon sx={{ color: '#000', fontSize: 16 }} />,
  },
  VRR: {
    OK: <VerifiedIcon sx={{ color: '#68BD00', fontSize: 16 }} />,
    NO_OK: <NewReleasesIcon sx={{ color: '#FF1414', fontSize: 16 }} />,
  },
  INCONSISTENCIES: <WarningIcon sx={{ color: '#FF1414', fontSize: 16 }} />,
  SERVICES: {
    SILO_ID: SiloIdIcon,
    SILO_SAT: SiloSatIcon,
    SILO_METRIX: SiloMetrixIcon,
  },
} as const;

export default ASSETS;
